import { JL } from "jsnlog";
import Vue from "vue";

// global error handler for vue errors
Vue.config.errorHandler = (err: Error, vm: Vue, info: string) => {
  // `info` is a Vue-specific error info, e.g. which lifecycle hook the error was found in.
  // eslint-disable-next-line
  console.log(err);

  JL().fatalException("Uncaught Exception", err);
};

// error handler for http requests.
// Vue.prototype.$http.interceptors.response.use(
//     response => {
//         return response;
//     },
//     error => {
//         console.log("axios response interceptor");
//         console.log(error: any);
// 						jL().fatalException('axios response error', error);
//         return Promise.reject(error: any);
//     });

// error handler for any remaining uncaught errors
window.onerror = (message, source, lineno, colno, error) => {
  try {
    JL().fatalException("windows.onerror", error);
  } catch (error: any) {
    // Do nothing..
  }

  // eslint-disable-next-line
  console.log("windows.onerror", error);
};
